import router from './router';
import store from './store';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import getPageTitle from '@/utils/get-page-title';

NProgress.configure({ showSpinner: false });

const whiteList = ['/login', '/'];

router.beforeEach((to, from, next) => {
  NProgress.start();
  document.title = getPageTitle(to.meta.title);

  const hasToken = store.getters.token;

  if (hasToken && to.path === '/login') {
    next({ path: '/' });
    NProgress.done();
    return;
  }

  if (!hasToken && whiteList.indexOf(to.path) === -1) {
    next(`/login?redirect=${to.path}`);
    NProgress.done();
    return;
  }

  next();
});

router.afterEach(() => {
  // finish progress bar
  NProgress.done();
});
